import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnicodeComponent } from './simple-icons-unicode.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnicodeComponent ],
    exports:      [ SimpleIconsUnicodeComponent ],
    bootstrap:    []
})
export class SimpleIconsUnicodeModule {}
